/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-update-dialog.vue?vue&type=template&id=5f9081bb&scoped=true&"
import script from "./add-update-dialog.vue?vue&type=script&lang=js&"
export * from "./add-update-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9081bb",
  null
  
)

export default component.exports